import Dexie from 'dexie';
import { Injectable } from '@angular/core';
import { LocalArticleInterface } from '../interfaces';


@Injectable({
  providedIn: 'root',
})
export class LocalArticleService extends Dexie {
  products!: Dexie.Table<LocalArticleInterface, string>;

  constructor() {
    super('ProductDatabase');
    this.version(1).stores({
      products: 'barcode, article_name, price',
    });
  }

  async addLocalArticles(productList: LocalArticleInterface[]) {
    await this.products.bulkPut(productList);
  }

  async getLocalArticleByBarcode(barcode: string): Promise<LocalArticleInterface | undefined> {
    return this.products.get(barcode);
  }
}
